package one.healthium.profile.ui.profile

import androidx.compose.runtime.Immutable

@Immutable
internal data class ProfileUiState(
    val loading: Boolean = false,
    val profile: ProfileUiModel? = null,
)
